import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './BannerList.module.css';
import AxiosUrl from '../AxiosUrl';
import { toast, ToastContainer } from 'react-toastify';
import { AiOutlinePlus, AiOutlineEdit, AiOutlineDelete, AiOutlineAppstore, AiOutlineUnorderedList } from 'react-icons/ai';
import { FiCamera } from 'react-icons/fi';

const Banner = () => {
    const uid = localStorage.getItem('id');
    const navigate = useNavigate();
    const [banner, setBanner] = useState([]);
    const [loading, setLoading] = useState(true);
    const [refresh, setRefresh] = useState(1);
    const [viewMode, setViewMode] = useState('list'); // 'list' or 'grid'

    useEffect(() => {
        setLoading(true);
        AxiosUrl.get(`get-banner/${uid}`)
            .then((res) => {
                setBanner(res.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error.response?.data);
                setLoading(false);
            });
    }, [refresh, uid]);

    const handleDelete = async (id) => {
        const confirmDelete = window.confirm(
            'Are you sure you want to delete this banner?'
        );
        if (confirmDelete) {
            AxiosUrl.post(`delete-banner/${uid}`, { id })
                .then((res) => {
                    setRefresh(refresh + 1);
                    toast.success(res.data);
                })
                .catch((error) => toast.error('Failed to delete banner'));
        }
    };

    const ActiveDeactive = async (data) => {
        AxiosUrl.post(`actve-banner/${uid}`, {
            id: data._id,
            status: data.status === 1 ? 0 : 1,
        })
            .then((res) => {
                setRefresh(refresh + 1);
                toast.success(res.data);
            })
            .catch((error) => toast.error('Failed to update status'));
    };

    return (
        <div className={styles.container}>
            <ToastContainer />

            {/* Header */}
            <div className={styles.header}>
                <div className={styles.headerLeft}>
                    <h1 className={styles.pageTitle}>Banners</h1>
                    <p className={styles.pageSubtitle}>
                        Manage your store banners and promotional images
                    </p>
                </div>
                <div className={styles.headerRight}>
                    <div className={styles.viewToggle}>
                        <button
                            className={`${styles.viewButton} ${viewMode === 'list' ? styles.viewButtonActive : ''}`}
                            onClick={() => setViewMode('list')}
                            title="List view"
                        >
                            <AiOutlineUnorderedList />
                        </button>
                        <button
                            className={`${styles.viewButton} ${viewMode === 'grid' ? styles.viewButtonActive : ''}`}
                            onClick={() => setViewMode('grid')}
                            title="Grid view"
                        >
                            <AiOutlineAppstore />
                        </button>
                    </div>
                    <button
                        className={styles.primaryButton}
                        onClick={() => navigate('/add-banner')}
                    >
                        <AiOutlinePlus className={styles.buttonIcon} />
                        Add Banner
                    </button>
                </div>
            </div>

            {/* Content Card */}
            <div className={styles.contentCard}>
                {loading ? (
                    <div className={styles.skeletonGrid}>
                        {[...Array(4)].map((_, i) => (
                            <div key={i} className={styles.skeletonBannerCard}>
                                <div className={styles.skeleton} style={{width: '100%', height: '180px', borderRadius: '0'}}></div>
                                <div className={styles.skeletonBannerCardContent}>
                                    <div className={styles.skeletonBannerInfo}>
                                        <div className={styles.skeleton} style={{width: '60%', height: '16px', marginBottom: '8px'}}></div>
                                        <div className={styles.skeleton} style={{width: '40%', height: '13px'}}></div>
                                    </div>
                                    <div className={styles.skeletonBannerActions}>
                                        <div className={styles.skeleton} style={{flex: 1, height: '36px', borderRadius: '6px'}}></div>
                                        <div className={styles.skeleton} style={{width: '36px', height: '36px', borderRadius: '6px'}}></div>
                                        <div className={styles.skeleton} style={{width: '36px', height: '36px', borderRadius: '6px'}}></div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : banner?.length === 0 ? (
                    <div className={styles.emptyState}>
                        <div className={styles.emptyIcon}><FiCamera /></div>
                        <h2 className={styles.emptyTitle}>No banners yet</h2>
                        <p className={styles.emptyDescription}>
                            Create your first banner to showcase promotions and featured products
                        </p>
                        <button
                            className={styles.primaryButton}
                            onClick={() => navigate('/add-banner')}
                        >
                            <AiOutlinePlus className={styles.buttonIcon} />
                            Add Banner
                        </button>
                    </div>
                ) : viewMode === 'grid' ? (
                    <div className={styles.bannersGrid}>
                        {banner.map((data, index) => (
                            <div key={data._id} className={styles.bannerCard}>
                                <div className={styles.bannerImageWrapper}>
                                    <img
                                        src={data.Data[0]?.image}
                                        alt="Banner"
                                        className={styles.bannerImage}
                                    />
                                    <div className={styles.statusBadge}>
                                        <span
                                            className={
                                                data.status === 1
                                                    ? styles.statusActive
                                                    : styles.statusInactive
                                            }
                                        >
                                            {data.status === 1 ? 'Active' : 'Inactive'}
                                        </span>
                                    </div>
                                </div>
                                <div className={styles.bannerCardContent}>
                                    <div className={styles.bannerInfo}>
                                        <h3 className={styles.bannerTitle}>
                                            Banner {index + 1}
                                        </h3>
                                        <p className={styles.bannerMeta}>
                                            Status: {data.status === 1 ? 'Published' : 'Draft'}
                                        </p>
                                    </div>
                                    <div className={styles.bannerActions}>
                                        <button
                                            className={styles.toggleButton}
                                            onClick={() => ActiveDeactive(data)}
                                            title={data.status === 1 ? 'Deactivate' : 'Activate'}
                                        >
                                            {data.status === 1 ? 'Deactivate' : 'Activate'}
                                        </button>
                                        <button
                                            className={styles.editButton}
                                            onClick={() =>
                                                navigate(`/edit-banner`, {
                                                    state: data,
                                                })
                                            }
                                            title="Edit banner"
                                        >
                                            <AiOutlineEdit />
                                        </button>
                                        <button
                                            className={styles.deleteButton}
                                            onClick={() => handleDelete(data._id)}
                                            title="Delete banner"
                                        >
                                            <AiOutlineDelete />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className={styles.bannersList}>
                        {banner.map((data, index) => (
                            <div key={data._id} className={styles.listItem}>
                                <div className={styles.listItemImage}>
                                    <img
                                        src={data.Data[0]?.image}
                                        alt="Banner"
                                        className={styles.listImage}
                                    />
                                </div>
                                <div className={styles.listItemInfo}>
                                    <h3 className={styles.listItemTitle}>Banner {index + 1}</h3>
                                    <p className={styles.listItemMeta}>
                                        Status: {data.status === 1 ? 'Published' : 'Draft'}
                                    </p>
                                </div>
                                <div className={styles.listItemStatus}>
                                    <span
                                        className={
                                            data.status === 1
                                                ? styles.statusActive
                                                : styles.statusInactive
                                        }
                                    >
                                        {data.status === 1 ? 'Active' : 'Inactive'}
                                    </span>
                                </div>
                                <div className={styles.listItemActions}>
                                    <button
                                        className={styles.toggleButton}
                                        onClick={() => ActiveDeactive(data)}
                                        title={data.status === 1 ? 'Deactivate' : 'Activate'}
                                    >
                                        {data.status === 1 ? 'Deactivate' : 'Activate'}
                                    </button>
                                    <button
                                        className={styles.editButton}
                                        onClick={() =>
                                            navigate(`/edit-banner`, {
                                                state: data,
                                            })
                                        }
                                        title="Edit banner"
                                    >
                                        <AiOutlineEdit />
                                    </button>
                                    <button
                                        className={styles.deleteButton}
                                        onClick={() => handleDelete(data._id)}
                                        title="Delete banner"
                                    >
                                        <AiOutlineDelete />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Banner;
